const reverseUrl = (urlName, ...params) => DJ_CONST.reverse[urlName](...params);

export default reverseUrl;



// WEBPACK FOOTER //
// ./src/utils/urls.js